import {CHATIWI_LANGUAGE_ORDER} from './languageManifest';

export const CHATIWI_LOCALES = CHATIWI_LANGUAGE_ORDER;

export type ChatiwiLocaleId = (typeof CHATIWI_LOCALES)[number];
export const CHATIWI_DEFAULT_LOCALE: ChatiwiLocaleId = `en-US`;
